
	<app-side-menu [(isExpanded)]="isExpanded">
	<app-side-menu-title>
		<span class="mat-title-medium">{{"Sonderzeit" | translate : "label-special-time" : "feature/project-special-time-menu"}}</span>
	</app-side-menu-title>
	<app-side-menu-content>
		<app-side-menu-group>
			<app-side-menu-group-title>
				{{"Art der Sonderzeit" | translate : "label-special-time-type": "feature/project-special-time-menu"}}
			</app-side-menu-group-title>
			<app-side-menu-group-content>
				<mat-radio-group [disabled]="true">
					<mat-radio-button [checked]="false">{{"Sonderöffnungszeit" | translate : "label-special-opening-time": "feature/project-special-time-menu"}}</mat-radio-button>
					<mat-radio-button [checked]="true">{{"Sonderschließzeit" | translate : "label-special-closing-time": "feature/project-special-time-menu"}}</mat-radio-button>
				</mat-radio-group>
			</app-side-menu-group-content>
		</app-side-menu-group>
		<p class="mat-body-medium holiday-menu__discription">
		{{"Über die Funktion “Alle Feiertage” werden alle offiziellen Feiertage des Bundeslandes in dem sich das Projekt befindet als Sonderschließzeit eingetragen. Die Feiertage betreffen den gesamten Projektzeitraum. Die Schließdauer an Feiertagen beträgt immer 24 Stunden. Jeder Feiertag kann nachträglich einzeln angepasst werden."
				| translate : "paragraph-add-holidays"}}
		</p>
		<section class="holiday-menu__operators">
				<button mat-button class="button--tertiary" (click)="_addHolidays()">
					{{"Hinzufügen" | translate : "add": "global"}}
				</button>
				<button mat-button (click)="isExpanded.set(false)">
							{{"Abbrechen" | translate : "cancel" : "global"}}
				</button>
		</section>
	</app-side-menu-content>
</app-side-menu>
